const STORAGE_KEY = "mendicino_favorites";

export function getFavorites(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function toggleFavorite(codigo: string): string[] {
  const favs = getFavorites();
  const idx = favs.indexOf(codigo);
  if (idx >= 0) {
    favs.splice(idx, 1);
  } else {
    favs.push(codigo);
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(favs));
  return favs;
}

export function isFavorite(codigo: string): boolean {
  return getFavorites().includes(codigo);
}
